import { useLocation, useNavigate } from 'react-router-dom';
import { ChatRoutingProvider } from '@trinity/chat-components/containers/Chat/RoutingProvider.js';

export const RoutingProvider = ({ children }: { children: React.ReactNode }) => {

  const location = useLocation();
  const navigate = useNavigate();

  return (
    <ChatRoutingProvider
      location={location}
      navigate={navigate}
    >
      {children}
    </ChatRoutingProvider>
  );
};